/** @format */

var certifytext;

$(function() {
    certifytext = $(".certify-label").html();
    //if ($(".inboxlink").length > 0) {
    //    $.getJSON(window.location.href.replace("#", "") + "/profile/HasNewInboxMessages", function(
    //        data
    //    ) {
    //        console.log(data);
    //        $(".inbox-spinner").remove();
    //        if (data && data.hasNew && data.hasNew === true) {
    //            $(".inboxlink span")
    //                .html(data.count)
    //                .removeClass("badge-danger")
    //                .addClass("badge-info")
    //                .show();
    //        } else if (data && data.count >= 0) {
    //            // no badge if nothing new
    //        }
    //    });
    //}

    if ($(".resources").length > 0) {
        $(".selectedcentre")
            .parent()
            .hide();

        $("#applicationform").on("shown.bs.modal", function(e) {
            $("#desigListSelect").on("select2:select", function(e) {
                var data = $("#desigListSelect").select2("data");
                //console.log(data[0].text);
                //console.log(data[0].id);

                $("#downloadapplication").hide();
                $("#applicationnotavailable").hide();

                $("#applicationnotavailable div.other").hide();
                $("#applicationnotavailable div.notindaycare").hide();

                $("#certify").prop("checked", false);
                $("#applicationselect").dropdown("toggle");

                $(".selectedcentre")
                    .html(data[0].text)
                    .parent()
                    .show();

                if (data[0].id === 2) {
                    $("#applicationnotavailable div.other").show();
                    $("#applicationnotavailable").show();
                } else if (data[0].id === 3) {
                    $("#applicationnotavailable div.notindaycare").show();
                    $("#applicationnotavailable").show();
                } else {
                    $(".certify-label").html(certifytext.replace("{0}", data[0].text));
                    $(".dl-link").hide();
                    $("#downloadapplication").show();
                }
            });

            $(document).on("click", "a.dropdown-item", function(e) {
                $("#downloadapplication").hide();
                $("#applicationnotavailable").hide();

                $("#applicationnotavailable div.other").hide();
                $("#applicationnotavailable div.notindaycare").hide();

                $("#certify").prop("checked", false);
                $("#applicationselect").dropdown("toggle");

                $(".selectedcentre")
                    .html($(this).html())
                    .parent()
                    .show();

                gtag("event", "Clicks", {
                    event_category: "Designated-Download-List",
                    event_label: $(this).html()
                });

                if ($(this).hasClass("other")) {
                    $("#applicationnotavailable div.other").show();
                    $("#applicationnotavailable").show();
                } else if ($(this).hasClass("notindaycare")) {
                    $("#applicationnotavailable div.notindaycare").show();
                    $("#applicationnotavailable").show();
                } else {
                    $(".certify-label").html(certifytext.replace("{0}", $(this).html()));
                    $(".dl-link").hide();
                    $("#downloadapplication").show();
                }

                return false;
            });
        });

        //$("#applicationselect2").on("change", function () {

        //    var value = $("#applicationselect").val();
        //    //console.log(value == 0);
        //    if (value == 1) {
        //        $(".certify-label").html(certifytext.replace("{0}", $("#applicationselect option:selected").text()));
        //        $(".dl-link").hide();
        //        $("#downloadapplication").show();
        //    } else if (value == 0) {
        //        $("#applicationnotavailable").show();
        //    }
        //});

        // Click the 'i certify...' checkbox
        $("#certify").change(function() {
            if (this.checked) {
                $(".dap_transfer").show();
                // $(".dl-link-regular").show();
                // $(".dl-link-after").show(); // hack to hide DAP stuff for now

                gtag("event", "Clicks", {
                    event_category: "Designated-Download-List",
                    event_label: "Certify-Checked"
                });
            } else {
                $(".dl-link").hide();
            }
        });

        $(".dap_transfer_yes").click(function() {
            $(".dl-link-regular").hide();
            $(".dl-link-transfer").show();
            $(".dl-link-after").show();
            gtag("event", "Clicks", {
                event_category: "Designated-Download-List",
                event_label: "Certify-Checked"
            });
        });

        $(".dap_transfer_no").click(function() {
            $(".dl-link-transfer").hide();
            $(".dl-link-regular").show();
            $(".dl-link-after").show();
            gtag("event", "Clicks", {
                event_category: "Designated-Download-List",
                event_label: "Certify-Checked"
            });
        });

        // on full subsidy application download
        $(".dl-link-regular a").click(function() {
            gtag("event", "Clicks", {
                event_category: "Designated-Download-List",
                event_label: "Application Download"
            });
        });

        $(".dl-link-transfer a").click(function() {
            gtag("event", "Clicks", {
                event_category: "Designated-Download-List",
                event_label: "DAP Transfer Download"
            });
        });
    }
});
